import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import { ToastContainer } from "react-toastify";
import Terms from "../../views/TermsAndConditions";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Helmet } from "react-helmet";

const TermsAndConditions = () => {
  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Terms & Conditions - BXI | Barter Exchange of India</title>
        <meta property="og:title" content="Terms & Conditions | BXI" />
        <meta
          name="og:description"
          content=" Discover BXI's Terms & Conditions, Privacy Policy, and agreements. Learn about the rules of Barter Exchange of India and our secure online marketplace"
        />
        <meta
          name="description"
          content=" Discover BXI's Terms & Conditions, Privacy Policy, and agreements. Learn about the rules of Barter Exchange of India and our secure online marketplace"
        />
         <meta
          name="keywords"
          content="terms and conditions, terms and policy, privacy policy, policies, terms & conditions, online marketplace, agreements, BXI, Barter Exchange Of India"
        />
      </Helmet>
      <Box>
        <Navbar />
      </Box>
      <ToastContainer style={{ fontSize: "16px" }} />

      <Paper
        sx={{ mt: "100px", width: "100%", border: "none", boxShadow: "none" }}
      >
        <Typography
          sx={{
            fontFamily: "Poppins",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: {
              xl: "26px",
              lg: "26px",
              md: "26px",
              sm: "20px",
              xs: "20px",
            },
            lineHeight: {
              xl: "36px",
              lg: "36px",
              md: "36px",
              sm: "30px",
              xs: "30px",
            },
            color: "#6B7A99",
            textAlign: "center",
            mx: "auto",
          }}
        >
          Terms and Conditions{" "}
        </Typography>
      </Paper>

      <Paper elevation={0}>
        <Box sx={{ ...ContactBoxOneStyle, mt: "25px" }}>
          <Terms />
        </Box>
      </Paper>

      <Footer />
    </React.Fragment>
  );
};

export default TermsAndConditions;

const ContactBoxOneStyle = {
  width: "90%",
  height: "auto",
  background: "#FFFFFF",
  fontFamily: "Poppins",
  borderRadius: "10px",
  zIndex: 10,
  display: "block",
  justifyContent: "space-evenly",
  mx: "auto",
};
